import React, { useState, Component } from 'react';
import { Link } from 'react-router-dom';
import { Navigation } from '../components/Navigation';
import { Footer } from '../components/Footer';
import { ArrowRight } from 'lucide-react';
export function SupportPage() {
  const [formData, setFormData] = useState({
    fullName: '',
    workEmail: '',
    company: '',
    title: '',
    description: '',
    impact: '',
    affected: '',
    dateStarted: '',
    stillHappening: true,
    frequency: '',
    environment: '',
    version: ''
  });
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    const emailBody = `
Full Name: ${formData.fullName}
Work Email: ${formData.workEmail}
Company: ${formData.company}

Issue: ${formData.title}
Impact: ${formData.impact || 'Not specified'}
Affected: ${formData.affected || 'Not specified'}

When it started: ${formData.dateStarted || 'Not specified'} (Still happening: ${formData.stillHappening ? 'Yes' : 'No'})
Frequency: ${formData.frequency || 'Not specified'}
Environment: ${formData.environment || 'Not specified'} (Version: ${formData.version || 'Not specified'})

Description:
${formData.description}
    `.trim();
    const mailtoLink = `mailto:support@meetsynthia.ai?subject=Support Request: ${encodeURIComponent(formData.title)}&body=${encodeURIComponent(emailBody)}`;
    window.location.href = mailtoLink;
    // Optional: Reset form after a delay
    setTimeout(() => {
      setFormData({
        fullName: '',
        workEmail: '',
        company: '',
        title: '',
        description: '',
        impact: '',
        affected: '',
        dateStarted: '',
        stillHappening: true,
        frequency: '',
        environment: '',
        version: ''
      });
    }, 1000);
  };
  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement>) => {
    const {
      name,
      value,
      type
    } = e.target;
    if (type === 'checkbox') {
      const checked = (e.target as HTMLInputElement).checked;
      setFormData({
        ...formData,
        [name]: checked
      });
    } else {
      setFormData({
        ...formData,
        [name]: value
      });
    }
  };
  return <div className="min-h-screen w-full bg-white selection:bg-[#0066FF] selection:text-white" data-id="element-2782">
      {/* Header */}
      <header className="fixed top-0 left-0 right-0 z-50 bg-white/90 backdrop-blur-md border-b border-gray-100" data-id="element-2783">
        <div className="w-full px-6 md:px-12 lg:px-24" data-id="element-2784">
          <div className="max-w-7xl mx-auto h-20 flex items-center" data-id="element-2785">
            <Link to="/" data-id="element-2786">
              <img src="https://cdn.magicpatterns.com/uploads/9qJGNjQNSV94689CCZT1kr/newTM_black_copy.png" alt="Synthia" className="h-8" data-id="element-2787" />
            </Link>
            <Navigation data-id="element-2788" />
          </div>
        </div>
      </header>

      <main className="pt-20" data-id="element-2789">
        {/* Hero Section */}
        <section className="relative w-full pt-20 pb-16 px-6 md:px-12 lg:px-24 overflow-hidden bg-white" data-id="element-2790">
          <div className="absolute top-0 right-0 pointer-events-none" style={{
          width: '100%',
          height: '800px'
        }} data-id="element-2791">
            <img src="https://cdn.magicpatterns.com/uploads/kga88EcdPJUPTBaJUremGs/background_thought.png" alt="" className="absolute right-0 top-[2%] w-[100%] h-auto opacity-90" data-id="element-2792" />
          </div>

          <div className="max-w-7xl mx-auto relative z-10" data-id="element-2793">
            <div className="flex flex-col space-y-8" data-id="element-2794">
              <div className="inline-flex items-center px-3 py-1 rounded-full border border-gray-200 bg-gray-50 w-fit" data-id="element-2795">
                <span className="text-xs font-medium text-gray-600 uppercase tracking-wider font-sans" data-id="element-2796">
                  SUPPORT
                </span>
              </div>

              <h1 className="text-5xl md:text-7xl font-bold leading-[0.95] tracking-tight text-black max-w-6xl font-['Syne']" data-id="element-2797">
                How can we help?
              </h1>

              <p className="text-lg md:text-xl text-gray-600 leading-relaxed max-w-none font-light whitespace-nowrap" data-id="element-2798">
                Submit a support request and our team will respond within one
                business day.
              </p>
            </div>
          </div>
        </section>

        {/* Form Section */}
        <section className="py-16 px-6 md:px-12 lg:px-24 bg-white" data-id="element-2799">
          <div className="max-w-3xl mx-auto" data-id="element-2800">
            <form onSubmit={handleSubmit} className="space-y-10" data-id="element-2801">
              {/* User Info Section */}
              <div className="space-y-6" data-id="element-2802">
                <h3 className="text-xl font-bold text-black font-['Syne'] border-b border-gray-100 pb-2" data-id="element-2803">
                  Your Information
                </h3>

                <div data-id="element-2804">
                  <label htmlFor="fullName" className="block text-sm font-medium text-gray-700 mb-2" data-id="element-2805">
                    Full name <span className="text-red-500" data-id="element-2806">*</span>
                  </label>
                  <input type="text" id="fullName" name="fullName" value={formData.fullName} onChange={handleChange} required className="w-full px-4 py-3 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-[#0066FF] focus:border-transparent" data-id="element-2807" />
                </div>

                <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-2808">
                  <div data-id="element-2809">
                    <label htmlFor="workEmail" className="block text-sm font-medium text-gray-700 mb-2" data-id="element-2810">
                      Work email <span className="text-red-500" data-id="element-2811">*</span>
                    </label>
                    <input type="email" id="workEmail" name="workEmail" value={formData.workEmail} onChange={handleChange} required className="w-full px-4 py-3 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-[#0066FF] focus:border-transparent" data-id="element-2812" />
                  </div>

                  <div data-id="element-2813">
                    <label htmlFor="company" className="block text-sm font-medium text-gray-700 mb-2" data-id="element-2814">
                      Company / workspace name{' '}
                      <span className="text-red-500" data-id="element-2815">*</span>
                    </label>
                    <input type="text" id="company" name="company" value={formData.company} onChange={handleChange} required className="w-full px-4 py-3 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-[#0066FF] focus:border-transparent" data-id="element-2816" />
                  </div>
                </div>
              </div>

              {/* Issue Details Section */}
              <div className="space-y-6" data-id="element-2817">
                <h3 className="text-xl font-bold text-black font-['Syne'] border-b border-gray-100 pb-2 mt-8" data-id="element-2818">
                  Issue Details
                </h3>

                <div data-id="element-2819">
                  <label htmlFor="title" className="block text-sm font-medium text-gray-700 mb-2" data-id="element-2820">
                    Short title / summary{' '}
                    <span className="text-red-500" data-id="element-2821">*</span>
                  </label>
                  <input type="text" id="title" name="title" value={formData.title} onChange={handleChange} required className="w-full px-4 py-3 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-[#0066FF] focus:border-transparent" data-id="element-2822" />
                </div>

                <div data-id="element-2823">
                  <label htmlFor="description" className="block text-sm font-medium text-gray-700 mb-2" data-id="element-2824">
                    Detailed description <span className="text-red-500" data-id="element-2825">*</span>
                  </label>
                  <textarea id="description" name="description" value={formData.description} onChange={handleChange} required rows={6} placeholder="Describe the issue in detail. Include steps to reproduce if applicable..." className="w-full px-4 py-3 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-[#0066FF] focus:border-transparent" data-id="element-2826" />
                </div>
              </div>

              {/* Impact & Environment Section */}
              <div className="space-y-6" data-id="element-2827">
                <h3 className="text-xl font-bold text-black font-['Syne'] border-b border-gray-100 pb-2 mt-8" data-id="element-2828">
                  Impact & Environment{' '}
                  <span className="text-sm font-normal text-gray-400" data-id="element-2829">
                    (optional)
                  </span>
                </h3>

                <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-2830">
                  <div data-id="element-2831">
                    <label htmlFor="impact" className="block text-sm font-medium text-gray-700 mb-2" data-id="element-2832">
                      Impact level
                    </label>
                    <select id="impact" name="impact" value={formData.impact} onChange={handleChange} className="w-full px-4 py-3 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-[#0066FF] focus:border-transparent bg-white" data-id="element-2833">
                      <option value="" data-id="element-2834">Select impact</option>
                      <option value="Blocker" data-id="element-2835">Blocker (system down)</option>
                      <option value="High" data-id="element-2836">
                        High (major workflow impacted)
                      </option>
                      <option value="Medium" data-id="element-2837">Medium</option>
                      <option value="Low" data-id="element-2838">Low</option>
                    </select>
                  </div>

                  <div data-id="element-2839">
                    <label htmlFor="affected" className="block text-sm font-medium text-gray-700 mb-2" data-id="element-2840">
                      Who is affected
                    </label>
                    <select id="affected" name="affected" value={formData.affected} onChange={handleChange} className="w-full px-4 py-3 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-[#0066FF] focus:border-transparent bg-white" data-id="element-2841">
                      <option value="" data-id="element-2842">Select scope</option>
                      <option value="Just me" data-id="element-2843">Just me</option>
                      <option value="My team" data-id="element-2844">My team</option>
                      <option value="Whole org" data-id="element-2845">Whole org</option>
                      <option value="External users/customers" data-id="element-2846">
                        External users/customers
                      </option>
                    </select>
                  </div>
                </div>

                <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-2847">
                  <div data-id="element-2848">
                    <label htmlFor="dateStarted" className="block text-sm font-medium text-gray-700 mb-2" data-id="element-2849">
                      When it started (First noticed)
                    </label>
                    <div className="flex items-center gap-4" data-id="element-2850">
                      <input type="date" id="dateStarted" name="dateStarted" value={formData.dateStarted} onChange={handleChange} className="flex-1 px-4 py-3 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-[#0066FF] focus:border-transparent" data-id="element-2851" />
                      <label className="flex items-center gap-2 cursor-pointer whitespace-nowrap" data-id="element-2852">
                        <input type="checkbox" name="stillHappening" checked={formData.stillHappening} onChange={handleChange} className="w-5 h-5 text-[#0066FF] border-gray-300 rounded focus:ring-[#0066FF]" data-id="element-2853" />
                        <span className="text-sm font-medium text-gray-700" data-id="element-2854">
                          Still happening?
                        </span>
                      </label>
                    </div>
                  </div>

                  <div data-id="element-2855">
                    <label htmlFor="frequency" className="block text-sm font-medium text-gray-700 mb-2" data-id="element-2856">
                      Frequency
                    </label>
                    <select id="frequency" name="frequency" value={formData.frequency} onChange={handleChange} className="w-full px-4 py-3 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-[#0066FF] focus:border-transparent bg-white" data-id="element-2857">
                      <option value="" data-id="element-2858">Select frequency</option>
                      <option value="Always" data-id="element-2859">Always</option>
                      <option value="Often" data-id="element-2860">Often</option>
                      <option value="Sometimes" data-id="element-2861">Sometimes</option>
                      <option value="Once" data-id="element-2862">Once</option>
                    </select>
                  </div>
                </div>

                <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-2863">
                  <div data-id="element-2864">
                    <label htmlFor="environment" className="block text-sm font-medium text-gray-700 mb-2" data-id="element-2865">
                      Environment
                    </label>
                    <select id="environment" name="environment" value={formData.environment} onChange={handleChange} className="w-full px-4 py-3 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-[#0066FF] focus:border-transparent bg-white" data-id="element-2866">
                      <option value="" data-id="element-2867">Select environment</option>
                      <option value="Web" data-id="element-2868">Web</option>
                      <option value="iOS" data-id="element-2869">iOS</option>
                      <option value="Android" data-id="element-2870">Android</option>
                      <option value="API" data-id="element-2871">API</option>
                      <option value="Browser extension" data-id="element-2872">
                        Browser extension
                      </option>
                    </select>
                  </div>

                  <div data-id="element-2873">
                    <label htmlFor="version" className="block text-sm font-medium text-gray-700 mb-2" data-id="element-2874">
                      Version (Optional)
                    </label>
                    <input type="text" id="version" name="version" value={formData.version} onChange={handleChange} placeholder="e.g. 2.4.1 or Chrome 120" className="w-full px-4 py-3 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-[#0066FF] focus:border-transparent" data-id="element-2875" />
                  </div>
                </div>
              </div>

              <div className="pt-6" data-id="element-2876">
                <button type="submit" className="w-full group relative inline-flex items-center justify-center px-8 py-4 text-lg font-bold text-white transition-all duration-200 bg-[#0066FF] font-['Syne'] hover:bg-black hover:scale-105 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-black" data-id="element-2877">
                  <span data-id="element-2878">SUBMIT REQUEST</span>
                  <ArrowRight className="ml-2 w-5 h-5 transition-transform group-hover:translate-x-1" data-id="element-2879" />
                </button>
              </div>
            </form>
          </div>
        </section>
      </main>

      <Footer data-id="element-2880" />
    </div>;
}